import * as React from 'react';
import FormDialog from '../../Common/Form/FormDialog/FormDialog';
import FormDialogFooter from '../../Common/Form/FormDialog/FormDialogFooter';
import PrimaryButton from '../../Common/Buttons/PrimaryButton';
import './NotificationDisplay.scss';

interface NotificationProps {
  message: string;
  emailSubject: string;
  supportEmail: string;
  orgName: string;
}

class NotificationDisplay extends React.Component<NotificationProps, {}> {
  render() {
    const { message, supportEmail, emailSubject, orgName } = this.props;
    return (
      <div className="NotificationDisplay">
        <FormDialog>
          <div className="NotificationDisplay-body">{message}</div>
          <FormDialogFooter>
            <div className="NotificationDisplay-footerWrapper">
              <a className="NotificationDisplay-contactLink" href={`mailto:${supportEmail}?subject=${emailSubject}`}>
                <PrimaryButton buttonId="it-NotificationDisplay-contactButton" text={`Contact ${orgName}`} />
              </a>
            </div>
          </FormDialogFooter>
        </FormDialog>
      </div>
    );
  }
}

export default NotificationDisplay;
